export { TopMessagePage as default } from '@/components/enpages/Company/TopMessage'
